import { FC, type JSX } from 'react';
import { DrawerSize } from '../event-history.types';
import { TwoWayCollapseLayoutDesktop } from './two-way-collapse-layout-desktop';

interface Props {
  bottomDrawerContent: JSX.Element;
  bottomDrawerExited: boolean;
  bottomDrawerHeight: DrawerSize;
  closedDrawerSize: number;
  renderTopDrawerHeaderIcon: () => JSX.Element;
  renderTopDrawerHeaderTitle: () => JSX.Element;
  setBottomDrawerExited: (exited: boolean) => void;
  setBottomDrawerHeight: (height: DrawerSize) => void;
  topDrawerContent: JSX.Element;
}

export const TwoWayCollapseView: FC<Props> = ({
  bottomDrawerContent,
  bottomDrawerExited,
  bottomDrawerHeight,
  closedDrawerSize,
  setBottomDrawerExited,
  setBottomDrawerHeight,
  topDrawerContent,
}): JSX.Element => {
  return (
    <TwoWayCollapseLayoutDesktop
      bottomDrawerContent={bottomDrawerContent}
      bottomDrawerExited={bottomDrawerExited}
      bottomDrawerHeight={bottomDrawerHeight}
      closedDrawerSize={closedDrawerSize}
      handleBottomDrawerEnter={() => setBottomDrawerExited(false)}
      handleBottomDrawerExit={() => setBottomDrawerExited(true)}
      setBottomDrawerHeight={setBottomDrawerHeight}
      topDrawerContent={topDrawerContent}
    />
  );
};
